import { repoSpaceMutators } from '@basehub/data/replicache/mutators/repo-space/mutators'
import { useReplicacheQueryV2 } from './use-replicache-query'
import { useRepoReplicache } from './use-repo-replicache'
import { Branch, SuggestedBranch } from '@basehub/data/replicache/index'
import { max } from 'date-fns'

export const useSuggestedBranches = () => {
  const { data } = useRepoReplicache()

  const suggestedBranchesQuery = useReplicacheQueryV2({
    key: ['suggested-branches', data?.spaceId],
    replicache: data?.replicache,
    fetcher: async (tx) => await repoSpaceMutators.listSuggestedBranches(tx),
  })

  const resolvedData = suggestedBranchesQuery?.data
    ? suggestedBranchesQuery.data
        .filter((sb) => {
          if (sb.resolution) return null
          const threeDaysInMilliseconds = 3 * 24 * 60 * 60 * 1000
          const wasCreated3DaysAgo =
            Date.now() - new Date(sb.createdAt).getTime() >
            threeDaysInMilliseconds
          return !wasCreated3DaysAgo
        })
        .slice()
        .sort(standardBranchSort)
    : suggestedBranchesQuery?.data

  return { ...suggestedBranchesQuery, data: resolvedData }
}

export function standardBranchSort(
  a: SuggestedBranch | Branch,
  b: SuggestedBranch | Branch
) {
  if (typeGuardDefaultBranch(a)) {
    if (a.isDefault) return -1
  }
  if (typeGuardDefaultBranch(b)) {
    if (b.isDefault) return 1
  }

  const keyToCompareFormBranchOrSuggestedBranchA = typeGuardDefaultBranch(a)
    ? (a.archivedAt ?? a.headCommit?.createdAt ?? a.createdAt)
    : a.createdAt
  const keyToCompareFormBranchOrSuggestedBranchB = typeGuardDefaultBranch(b)
    ? (b.archivedAt ?? b.headCommit?.createdAt ?? b.createdAt)
    : b.createdAt

  return (
    max([
      new Date(keyToCompareFormBranchOrSuggestedBranchB),
      new Date(b.createdAt),
    ]).getTime() -
    max([
      new Date(keyToCompareFormBranchOrSuggestedBranchA),
      new Date(a.createdAt),
    ]).getTime()
  )
}

const typeGuardDefaultBranch = (
  branch: Branch | SuggestedBranch
): branch is Branch =>
  'headCommitId' in branch && 'workingRootBlockId' in branch
